export const Uploads = {
  maxFileSize: 30 * 1024 * 1024,
};

export const superOrgLogo =
  'https://www.joinfurther.com/assets/images/invest-further-sq.jpg';
